<template>
  <div class="gf_price-intro__item">
    <div class="gf_price-intro__item--icon">
      <img v-if="planStarter" src="../../assets/check-disabled.svg" alt="">
      <img v-else src="../../assets/check.svg" alt="">
    </div>
    <div
      class="gf_price-intro__item--title"
      :class="{ title_is_active: active }"
    >
      <div :class="{'starter-disable': planStarter}" v-html="$t(text)" style="display: inline"></div>
      <div class="gf_price-intro__item--tooltip" v-if="tooltip && tooltip.show">
        <PricingTooltips
          type="default"
          :is-beta="isBeta"
          :image="tooltip.image"
          :title="tooltip.title"
          :description="tooltip.description" />
      </div>
      <div class="gf_price-intro__item__tag--new" v-if="isNew" v-html="label ? $t(`${label}`) : $t('dataNewPlan.new')"></div>
      <div class="gf_price-intro__item__tag--beta" v-else-if="isBeta" v-html="label ? $t(`${label}`) : $t('dataNewPlan.beta')"></div>
      <div class="gf_price-intro__item__tag--new" v-else-if="label">{{ $t(`${label}`) }}</div>
    </div>
  </div>
</template>

<script>
import PricingTooltips from "@/modules/Pricing/components/PricingTooltips";

export default {
  name: "PricingFeatureItem",
  components: {
    PricingTooltips
  },
  props: {
    text: String,
    isNew: Boolean,
    isBeta: Boolean,
    active: Boolean,
    showTooltip: Boolean,
    planStarter: Boolean,
    label: {
      type: String,
      default: undefined
    },
    tooltip: {
      show: Boolean,
      image: String,
      title: String,
      description: String,
    }
  },
};
</script>
